/** @format */

import Header from "../layout/common/Header";
import { Outlet, Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { AuthProvider } from "../auth/AuthProvider";
const Main = ({ socket }) => {
  const [leadCreationIndicator, setLeadCreationIndicator] = useState(0);
   
  const accessToken = localStorage.getItem("token") ? localStorage.getItem("token") : '';
  
  useEffect(() => { 
    console.log('Main');
  }, []);

  return (
    <AuthProvider accessToken={accessToken}>
      <div className="wrapper">

        <div id="content">
          <Header socket={socket} leadCreationIndicator={leadCreationIndicator} />
          <div className="overflow-auto" style={{ height: "80vh" }}>
            <Outlet context={[leadCreationIndicator, setLeadCreationIndicator]} />
          </div>
        </div>
      </div>
    </AuthProvider>
  );
};

export default Main;